export const requiredErr = 'پرکردن این فیلد الزامی است'
export const phoneErr = 'شماره موبایل معتبر نیست'
export const nationalIDErr = 'کدملی معتبر نیست'
export const stringErr = 'مقدار وارد شده معتبر نیست'
export const otpCodeErr = 'کد تاییدیه معتبر نیست'
export const emailErr = 'آدرس ایمیل معتبر نیست'

export const ValidationsMessages = {
  requiredErr,
  phoneErr,
  stringErr,
  otpCodeErr,
  emailErr,
}

export default ValidationsMessages
